import { signal } from '@preact/signals-react';

export const ApplicationLocale = signal('');
export const ApplicationLanguage = signal('');
